module.exports = __webpack_public_path__ + "static/OP_Logo_Main_Footer-9f5dd2a80548239d08a4e054651b6ffb.svg";